/* ===== THORNWOVEN 2 — SCROLL ENGINE ===== */
/* Lenis smooth scroll + GSAP ScrollTrigger bridge */

(function () {
  'use strict';

  // Initialize Lenis
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smooth: true,
    smoothTouch: false,
  });

  // Expose globally for other modules
  window.lenis = lenis;

  // Register GSAP ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);

  // Connect Lenis to GSAP
  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  // Scroll progress bar
  const progressBar = document.getElementById('scrollProgress');
  if (progressBar) {
    lenis.on('scroll', ({ progress }) => {
      document.documentElement.style.setProperty('--scroll-progress', progress);
    });
  }

  // Nav scroll behavior
  const nav = document.getElementById('nav');
  if (nav) {
    lenis.on('scroll', ({ scroll }) => {
      if (scroll > 50) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    });
  }

  // Helper: stop/start scroll for modals
  window.lockScroll = function () {
    lenis.stop();
  };

  window.unlockScroll = function () {
    lenis.start();
  };

  // Smooth anchor scrolling
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const target = this.getAttribute('href');
      if (target === '#') return;
      const el = document.querySelector(target);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    });
  });
})();
